export enum TokenType {
    None = 0,
    AccessToken = 1 << 0,
    JWT = 1 << 1,
    Persistent = 1 << 2,
}
